import { useAlert } from 'components/alert'
import { PecFormApi, resetAllFieldStates } from 'components/form'
import { confirm } from 'components/modals/confirm'
import { useCallback } from 'react'

import AtestadoModel from '../components/model-atestado'

const DEFAULT_SUCCESS_MESSAGE = 'Cadastro de atestado cancelado com sucesso.'

interface UseAtestadoCancelarCadastroProps {
  isEmailCidadaoDirty: boolean
  setIsEmailCidadaoCanceled(value: boolean): void
  successMessage?: string
}

export function useAtestadoCancelarCadastro(props: Readonly<UseAtestadoCancelarCadastroProps>) {
  const { isEmailCidadaoDirty, setIsEmailCidadaoCanceled, successMessage = DEFAULT_SUCCESS_MESSAGE } = props

  const alert = useAlert()

  const cancelarCadastro = useCallback(
    (form: PecFormApi<AtestadoModel>) => {
      alert('success', successMessage)
      setIsEmailCidadaoCanceled(true)
      setTimeout(() => form.reset())
    },
    [alert, setIsEmailCidadaoCanceled, successMessage]
  )

  return useCallback(
    (form: PecFormApi<AtestadoModel>) => {
      const hasChanges = form.getState().dirty || isEmailCidadaoDirty

      if (hasChanges) {
        confirm({
          title: 'Deseja cancelar a inclusão?',
          body: 'As alterações realizadas serão perdidas.',
          cancelLabel: 'Não, continuar inclusão',
          confirmLabel: 'Sim, cancelar inclusão',
          onConfirm: () => cancelarCadastro(form),
        })()
      } else {
        setIsEmailCidadaoCanceled(true)
      }

      resetAllFieldStates(form)
    },
    [cancelarCadastro, isEmailCidadaoDirty, setIsEmailCidadaoCanceled]
  )
}
